jQuery(function($){
  
    const closePopup    = document.querySelector('.close-popup');
    const crossbtn      = document.querySelector('.cross-btn');
    const productfilter = document.querySelector('.product-filter'); 
    const toggleButton  = document.querySelector('.filter-toggle');
    const submitBtn     = document.querySelector('.submit-show-btn');   // NEW
 
    const CARD_SELECTOR   = '.juo-card';
    const GRID_SELECTOR   = '.juo-grid';
    const PILLS_SELECTOR  = '.pills-row .pill, .filter-options .filter-option';
    const INPUTS_SELECTOR = '.content-container input[type=checkbox], .content-container input[type=radio]';
    const CLEAR_SELECTOR  = '.bottom-button-container .cancel';
    const LOGIC_MODE      = 'AND';
    const CLEAR_TAGS      = ['all-meals','all'];
 
    const normalize = (s) =>
      (s || '')
        .toString()
        .toLowerCase()
        .normalize('NFKD').replace(/[\u0300-\u036f]/g, '')  
        .replace(/[^a-z0-9]+/g, '-')                       
        .replace(/^-+|-+$/g, '');  
 
    function setButtonCount(count){
      if (!submitBtn) return;
      const noun = count === 1 ? 'meal' : 'meals';
      submitBtn.textContent = `Show ${count} ${noun}`;
    }

    function primeCards($cards){
      $cards.each(function(){
        const raw  = $(this).attr('data-tags') || '';
        const tags = raw.split(',').map(t => normalize(t.trim())).filter(Boolean);
        $(this).data('tags', new Set(tags));
      });
    }

    function getSelectedFilters(){
      const pills = $(PILLS_SELECTOR).filter('.active');
      const pillTags = $.makeArray(pills).map(el => {
        const $el = $(el);
        return normalize($el.data('tag') || $el.data('filter') || $el.text());
      });

      const inputs = $(INPUTS_SELECTOR).filter(':checked');
      const inputTags = $.makeArray(inputs).map(el => normalize($(el).val()));

      return [...new Set([...pillTags, ...inputTags].filter(Boolean))];
    }

    function matches(cardTagSet, filters){
      if (!filters.length) return true;
      if (LOGIC_MODE === 'OR') return filters.some(f => cardTagSet.has(f));
      return filters.every(f => cardTagSet.has(f));
    }
 
    function applyFilters(){
      const filters = getSelectedFilters();
      const $cards  = $(CARD_SELECTOR);
      let visible = 0;

      $cards.each(function(){
        let tagSet = $(this).data('tags');
        if (!(tagSet instanceof Set)) {
          const raw = $(this).attr('data-tags') || '';
          tagSet = new Set(raw.split(',').map(t => normalize(t.trim())).filter(Boolean));
          $(this).data('tags', tagSet);
        }
        const show = matches(tagSet, filters);
        $(this).toggleClass('is-hidden', !show);
        if (show) visible++;
      });

      setButtonCount(visible);  
      return visible;
    }
    
    document.addEventListener("setFilters", function(event) {
        applyFilters();  
    });
 
    const $grid  = $(GRID_SELECTOR);
    const $cards = $grid.length ? $grid.find(CARD_SELECTOR) : $(CARD_SELECTOR);
    primeCards($cards);
    applyFilters();  

     
    toggleButton && toggleButton.addEventListener('click', () => {
      productfilter && productfilter.classList.toggle('active');
      document.body.classList.add('overflow-hidden');
    });

    closePopup && closePopup.addEventListener('click', () => {
      productfilter && productfilter.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
    });

    crossbtn && crossbtn.addEventListener('click', () => {
      productfilter && productfilter.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
    });
     
    $(document).on('click', PILLS_SELECTOR, function(){
      const $btn = $(this);
      const tag = normalize($btn.data('tag') || $btn.data('filter') || $btn.text());

      if (CLEAR_TAGS.includes(tag)) {
        $(PILLS_SELECTOR).removeClass('active');
        $(INPUTS_SELECTOR).prop('checked', false);
      } else {
        $btn.toggleClass('active');
      }
      applyFilters();
    });

    $(document).on('change', INPUTS_SELECTOR, function(){
      applyFilters();
    });

    $(document).on('click', CLEAR_SELECTOR, function(e){
      e.preventDefault();
      $(PILLS_SELECTOR).removeClass('active');
      $(INPUTS_SELECTOR).prop('checked', false);
      applyFilters();
    });
 
    submitBtn && submitBtn.addEventListener('click', (e) => {
      e.preventDefault();
      productfilter && productfilter.classList.remove('active');
      document.body.classList.remove('overflow-hidden');

       
      const grid = document.querySelector(GRID_SELECTOR);
      if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  $(document).ready(function () {
    // -------------------------------
    // TEMPLATE OVERRIDES
    // -------------------------------
    const $pageTemplateEl = $('.delivery-selection.meal-discount-selection-wrapper');
    const templateSuffix = ($pageTemplateEl.attr('data-template') || '').trim();

    const TEMPLATE_OVERRIDES = {
      'tessas-mealplan-jan': {
        // Jan 5, 2026 11:59 PM local time
        fixedDateTimeLocal: { y: 2026, m: 1, d: 5, hh: 23, mm: 59, ss: 0 },
      },
    };

    function makeLocalDateTime(parts) {
      // parts: {y,m,d,hh,mm,ss} with m = 1..12
      return new Date(parts.y, parts.m - 1, parts.d, parts.hh, parts.mm, parts.ss || 0, 0);
    }

    const activeOverride = TEMPLATE_OVERRIDES[templateSuffix] || null;

    // -------------------------------
    // EXISTING CONSTANTS / SELECTORS
    // -------------------------------
    const DELIVERY_CODES = {
      Wednesday: 'LMV',
      Saturday: 'LMVD',
    };

    const Loader = {
      el: null,
      ensure() {
        this.el = this.el || document.getElementById('page-loader');
      },
      show() {
        this.ensure();
        if (this.el) this.el.classList.remove('hidden');
      },
      hide() {
        this.ensure();
        if (this.el) this.el.classList.add('hidden');
      },
    };

    const $wrapper = $('#delivery-options');
    const $satLabel = $wrapper.find("label[for='day-selector-sat']");
    const $wedLabel = $wrapper.find("label[for='day-selector-wed']");
    const $satDateEl = $satLabel.find('.sat-date');
    const $wedDateEl = $wedLabel.find('.wed-date');
    const $inputs = $wrapper.find('.delivery-day-selector');
    const $code = $('#delivery-code');
    const $countdown = $('.diifrtm');
    const $hulllu = $countdown.find('.hulllu');
    const $bullu = $countdown.find('.bullu');

    const WED = 1; // Wed
    const SAT = 6; // Sat

    const nowLocal = () => new Date();

    const DAY_TO_LABEL = {
      Wednesday: 'delivery every monday',
      Saturday: 'delivery every monday',
    };
    const DAY_TO_CODE = {
      Wednesday: 'LMV',
      Saturday: 'LMVD',
    };

    // -------------------------------
    // DATE HELPERS
    // -------------------------------
    function nextWeekday(targetDow, base = nowLocal()) {
      const d = new Date(base);
      d.setHours(0, 0, 0, 0);
      const currentDow = d.getDay();
      let delta = (targetDow - currentDow + 7) % 7;
      if (delta === 0) delta = 7;
      d.setDate(d.getDate() + delta);
      return d;
    }

    function previousWeekday(targetDow, fromDate) {
      const d = new Date(fromDate);
      d.setHours(0, 0, 0, 0);
      const dow = d.getDay();
      let delta = (dow - targetDow + 7) % 7;
      if (delta === 0) delta = 7;
      d.setDate(d.getDate() - delta);
      return d;
    }

    function atTime(dayDate, h, m, s) {
      const d = new Date(dayDate);
      d.setHours(h, m, s || 0, 0);
      return d;
    }

    // "05 Jan" for the radio labels
    function formatShortDayLabel(d) {
      const locale = navigator.language || 'en-US';
      const day = String(d.getDate()).padStart(2, '0');
      const short = d.toLocaleString(locale, { month: 'short' });
      return `${day} ${short.charAt(0).toUpperCase() + short.slice(1)}`;
    }

    // "5 January" for .delivery-wed-date (your existing element)
    function formatLongMonthLabel(d) {
      const day = d.getDate();
      const month = d.toLocaleString('en-US', { month: 'long' });
      return `${day} ${month}`;
    }

    // Your cutoff rules for normal templates (kept as-is)
    function cutoffForDelivery(deliveryDate) {
      const dow = deliveryDate.getDay();
      if (dow === WED) {
        const prevFri = previousWeekday(1, deliveryDate);
        return atTime(prevFri, 23, 59, 0);
      } else if (dow === SAT) {
        const prevTue = previousWeekday(2, deliveryDate);
        return atTime(prevTue, 23, 59, 0);
      }
      // Fallback for other days
      const prevDay = new Date(deliveryDate);
      prevDay.setDate(prevDay.getDate() - 1);
      return atTime(prevDay, 23, 59, 0);
    }

    function nextAvailable(targetDow) {
      let candidate = nextWeekday(targetDow);
      let cutoff = cutoffForDelivery(candidate);
      let attempts = 0;
      const maxHops = 8;

      while (nowLocal() > cutoff && attempts < maxHops) {
        candidate.setDate(candidate.getDate() + 7);
        cutoff = cutoffForDelivery(candidate);
        attempts++;
      }
      return { date: candidate, cutoff };
    }

    // -------------------------------
    // MODEL COMPUTATION
    // -------------------------------
    function computeModel() {
      // Fixed template: force delivery date/time and use that as countdown target.
      if (activeOverride?.fixedDateTimeLocal) {
        const fixedDT = makeLocalDateTime(activeOverride.fixedDateTimeLocal);
        const fixedDay = new Date(fixedDT);
        fixedDay.setHours(0, 0, 0, 0);

        const fixed = {
          date: fixedDay,     // for labels
          cutoff: fixedDT,    // countdown target = Jan 5, 2026 11:59 PM local
        };

        return {
          first: fixed,
          second: fixed,
          wed: fixed,
          sat: fixed,
          isFixedTemplate: true,
        };
      }

      // Normal templates: your existing next-available logic.
      const wed = nextAvailable(WED);
      const sat = nextAvailable(SAT);
      const list = [wed, sat].sort((a, b) => a.date - b.date);
      return {
        first: list[0],
        second: list[1],
        wed,
        sat,
        isFixedTemplate: false,
      };
    }

    // -------------------------------
    // RENDERING
    // -------------------------------
    function renderDates(model) {
      $satDateEl.text(formatShortDayLabel(model.sat.date));
      $wedDateEl.text(formatShortDayLabel(model.wed.date));

      if (!model.isFixedTemplate) {
        const earliestIsWed = model.first.date.getDay() === WED;
        if (earliestIsWed) {
          $('#delivery-options').css('flex-direction', 'row-reverse');
        } else {
          $('#delivery-options').css('flex-direction', '');
        }
      } else {
        // On fixed template, keep layout stable (optional)
        $('#delivery-options').css('flex-direction', '');
      }
    }

    function formatDuration(ms) {
      if (ms <= 0) return '00:00:00';
      const totalSec = Math.floor(ms / 1000);
      const hours = Math.floor(totalSec / 3600);
      const mins = Math.floor((totalSec % 3600) / 60);
      const secs = totalSec % 60;
      const pad = (n) => String(n).padStart(2, '0');
      return `${pad(hours)}:${pad(mins)}:${pad(secs)}`;
    }

    function selectedCutoff(model) {
      // Fixed template always counts down to the fixed datetime (ignores Wed/Sat selection).
      if (model.isFixedTemplate) return model.first.cutoff;

      const val = $wrapper.find('.delivery-day-selector:checked').val();
      // if (val === 'Wednesday') return model.wed.cutoff;
      // if (val === 'Saturday') return model.sat.cutoff;
      return model.wed.cutoff
    }

    function renderCountdown(model) {
      const cutoff = selectedCutoff(model);
      const msLeft = cutoff - nowLocal();
      $hulllu.text(formatDuration(msLeft));
      $bullu.text('');

       function formatDayLabel(dateStr) {
        const date = new Date(dateStr);
        const day = date.getDate();
        const month = date.toLocaleString('en-US', { month: 'long' });
        return `${day} ${month}`;
      }
      console.log(model.wed.date)
      document.querySelector('.delivery-wed-date').textContent = formatDayLabel(model.wed.date);
    }

    // -------------------------------
    // TICK LOOP
    // -------------------------------
    let cachedKey = '';
    function tick() {
      const model = computeModel();

      const key = model.isFixedTemplate
        ? `FIXED|${model.first.cutoff.toString()}`
        : `${model.wed.date.toDateString()}|${model.sat.date.toDateString()}`;

      if (key !== cachedKey) {
        cachedKey = key;
        renderDates(model);
      }

      renderCountdown(model);
    }

    $inputs.on('change', function () {
      tick();
    });

    // Start
    tick();
    setInterval(tick, 1000);

    // -------------------------------
    // MEAL CARD PRICE / SELECTION LOGIC (YOUR EXISTING CODE)
    // -------------------------------
    (function ($) {
      var $section = $('.meal-discount-selection-wrapper');
      var $mealOptions = $section.find('.meal-options');
      if (!$mealOptions.length) return;

      function currentMode() {
        var phandle = $('#juo-products-section').attr('data-handle');
        if (!phandle) return 'subscription';
        if (phandle === 'tessas-mealbox') return 'onetime';
        return 'subscription';
      }

      function updateCards() {
        var mode = currentMode();

        $mealOptions.find('.meal-card').each(function () {
          var $card = $(this);

          var total, per, discount;
          if (mode === 'subscription') {
            total = $card.data('sub-total');
            per = $card.data('sub-per');
            discount = $card.data('sub-discount');
          } else {
            total = $card.data('ot-total');
            per = $card.data('ot-per');
            discount = $card.data('ot-discount');
          }

          if (total) {
            $card.find('.js-price-total').text(total);
          }
          if (per) {
            $card.find('.js-price-per').text(per);
          }

          var $badge = $card.find('.js-discount-badge');
          if ($card.hasClass('is-selected') && discount) {
            $badge.text(discount).show();
          } else {
            $badge.hide();
          }
        });
      }

      function selectCard($card) {
        $mealOptions
          .find('.meal-card')
          .removeClass('is-selected')
          .find('input[type="radio"]')
          .prop('checked', false);

        $card
          .addClass('is-selected')
          .find('input[type="radio"]')
          .prop('checked', true);

        updateCards();
      }

      // Clicking a card
      $mealOptions.on('click', '.meal-card', function (e) {
        e.preventDefault();

        selectCard($(this));

        var meals = parseInt($(this).data('meals'), 10) || 0;
        if (meals > 0) {
          $('.current-meal-count').text(meals);
        }

        // Trigger delivery tick/render
        $inputs.trigger('change');

        $('.juo-layout').addClass('juo-layout-enable');
        $('.juo-layout').css('opacity', 1);
        $('.juo-layout').css('pointer-events', 'initial');
        $([document.documentElement, document.body]).animate(
          {
            scrollTop: $('.juo-layout').offset().top - 70,
          },
          500
        );
      });

      updateCards();
    })(jQuery);
  });

 
  

$(document).ready(function () {
  var pid = $('#juo-products-section').attr('data-pid');
  var phandle = $('#juo-products-section').attr('data-handle');
  const pending = new Map();

  const SELECTORS = {
    card: '.juo-card',
    addBtn: '.add-to-cart',
    qtyWrap: '.product-qty',
    totalEl: '.cartTotal',
    shippingEl: '.at-che',
    discountEl: '.at-cheee',
    grandEl: '.cartTotalll',
    grandElMobile: '.cartTotalMob',
    mealCount: '.cont-crt',
    mealOffer: '.offrs',
    mealText: '.txxxt',
    mealBar: '.progrss-bar',
    freeShipHeadline: '#headline',
    freeShipFill: '#progressFill',
    dayRadio: '.delivery-day-selector',
    cartGoBtn: '.checkout-btn',
  };

  const formatMoney = (cents) => '€' + (cents / 100).toFixed(2);

let TIER_TOTALS_EUR;

if (phandle === 'tessas-jan-box') {
  // Januari deal
  TIER_TOTALS_EUR = {
    4: 47.50,
    6: 60,
    10: 90,
    14: 112.50
  };

} else if (phandle === 'tessas-gratis-maaltijden-deal') {
  // Gratis maaltijden deal
  TIER_TOTALS_EUR = {
    6: 90,
    8: 108,
    10: 128,
    14: 165
  };

} else if (phandle === 'tessas-6-weken-transformatie') {
  // 6 weken transformatie
  TIER_TOTALS_EUR = {
    7: 99,
    14: 191
  };

} else {
  // fallback (voorkomt €0 als er ooit een handle mist)
  TIER_TOTALS_EUR = {
    4: 47.50,
    6: 60,
    10: 90,
    14: 112.50
  };
}
  const tierTotalCents = (meals) => Math.round((Number(TIER_TOTALS_EUR[meals] || 0) || 0) * 100);

  function getSelectedDay() {
    return $(SELECTORS.dayRadio + ':checked').val() || 'Wednesday';
  }

  function getDeliveryCode(day) {
    return day === 'Wednesday' ? 'LMV' : 'LMVD';
  }

  function parseDiscount(str) {
    if (!str) return 0;
    var m = String(str).match(/([\d.,]+)/);
    if (!m) return 0;
    return parseFloat(m[1].replace(',', '.')) || 0;
  }

  function isOneTimeMode() {
    if (phandle === 'tessas-mealbox') return true;
    var v = $('[name="purchase_type"]:checked').val();
    return v === 'one_time' || v === 'onetime';
  }

  function getSelectedMinMeals() {
    var $sel = $('.meal-card.is-selected').first();
    if ($sel.length) return parseInt($sel.data('meals'), 10) || 0;
    var $first = $('.meal-card').first();
    if ($first.length) return parseInt($first.data('meals'), 10) || 0;
    return 0;
  }

  function getTotalPendingQty() {
    let q = 0;
    pending.forEach((p) => (q += (p.qty || 0)));
    return q;
  }

  function updateAutoselectVisibility(totalQty) {
    var targetMeals = getSelectedMinMeals();
    if (totalQty >= targetMeals) {
      $('.autoselect-wrapper').attr('hidden', true);
      $('.autoselect-hr').attr('hidden', true);
    } else {
      var rm = targetMeals - totalQty;
      $('.current-meal-count').html(rm);
      $('.autoselect-wrapper').removeAttr('hidden');
      $('.autoselect-hr').removeAttr('hidden');
    }
    if ($('#customCartDrawer').hasClass('mobile-cart-active') == false) {
      $('.autoselect-wrapper.mobile').attr('hidden', true);
    }
  }

  const MEAL_TIERS = (function buildTiers() {
    const tiers = [];
    $('.meal-card').each(function () {
      const $c = $(this);
      const meals = parseInt($c.data('meals'), 10) || 0;
      if (!meals) return;
      const subText = $c.data('sub-discount') || '';
      const otText = $c.data('ot-discount') || '';
      tiers.push({
        meals,
        subPercent: parseDiscount(subText),
        otPercent: parseDiscount(otText),
        subText,
        otText,
        $card: $c,
      });
    });
    tiers.sort((a, b) => a.meals - b.meals);
    return tiers;
  })();

  function renderCards() {
    $(SELECTORS.card).each(function () {
      const $card = $(this);
      const variantId = String($card.data('variant-id'));
      const item = pending.get(variantId);

      const $existingBtn = $card.find('.add-to-cart').first();
      const $existingWrap = $existingBtn.length ? $existingBtn.closest('.button-wrapper').addBack().first() : null;

      $card.find(SELECTORS.qtyWrap).remove();

      if (item && item.qty > 0) {
        if ($existingWrap) $existingWrap.hide();
        $card.append(
          '<div class="product-qty" data-variant-id="' +
            variantId +
            '">' +
            '<button class="qty-btn minus" data-variant-id="' +
            variantId +
            '">-</button>' +
            '<span class="qty-count">' +
            item.qty +
            '</span>' +
            '<button class="qty-btn plus" data-variant-id="' +
            variantId +
            '">+</button>' +
            '<button class="qty-btn remove" style="display:none;" data-variant-id="' +
            variantId +
            '">x</button>' +
            '</div>'
        );
      } else {
        if ($existingWrap) $existingWrap.show();
      }
    });
  }

  function renderMiniCartFromPending() {
    const $cart = $('#cartItems').empty();

    const entries = Array.from(pending.values()).filter((p) => p.qty > 0);
    if (!entries.length) {
      $cart.html('<p class="cart-toolf-empty">Your cart is empty.</p>');
      $(SELECTORS.totalEl).text('€0.00');
      renderCards();
      return;
    }

    entries.forEach((p) => {
      const $card = $('.juo-card[data-variant-id="' + p.variantId + '"]');
      const price = Number($card.attr('data-price')) || 0;
      const title = $card.find('.for-juo-tiitle').html();
      const img = $card.find('img').first().attr('src') || '';

      $cart.append(
        '<div class="cart-item" data-variant-id="' +
          p.variantId +
          '">' +
          (img ? '<img src="' + img + '" >' : '') +
          '<div class="cart-item-info">' +
          '<p>' +
          title +
          '</p>' +
          '<p class="qui-car-pp">' +
          formatMoney(price) +
          '</p>' +
          '<div class="cart-quenntity">' +
          '<button class="qty-btn minus" data-variant-id="' +
          p.variantId +
          '">-</button>' +
          '<span>' +
          p.qty +
          '</span>' +
          '<button class="qty-btn plus" data-variant-id="' +
          p.variantId +
          '">+</button>' +
          '<button class="qty-btn remove" data-variant-id="' +
          p.variantId +
          '">x</button>' +
          '</div>' +
          '</div>' +
          '</div>'
      );
    });

    const totals = computeTotals();
    $(SELECTORS.totalEl).text(formatMoney(totals.subtotalCents));
  }

  function computeTotals() {
    let totalQty = 0;
    pending.forEach((p) => {
      totalQty += p.qty || 0;
    });

    const requiredMeals = getSelectedMinMeals();
    const subtotalCents = tierTotalCents(requiredMeals);
    let shippingCents = 0;

if (
  phandle === 'tessas-gratis-maaltijden-deal' ||
  phandle === 'tessas-6-weken-transformatie'
) {
  shippingCents = 995; // €9.95
}
    const discountCents = 0;
    const grandCents = Math.max(subtotalCents + shippingCents - discountCents, 0);

    return {
      subtotalCents,
      discountCents,
      shippingCents,
      grandCents,
      totalQty,
      requiredMeals,
    };
  }

  function renderMealBanner(data) {
    const { totalQty, requiredMeals } = data;

    const $count = $(SELECTORS.mealCount);
    const $offrs = $(SELECTORS.mealOffer);
    const $text = $(SELECTORS.mealText);
    const $bar = $(SELECTORS.mealBar);

    const target = requiredMeals || 0;
    const remain = Math.max(target - totalQty, 0);
    const progress = target > 0 ? Math.min((totalQty / target) * 100, 100) : 0;

    $count.text(target ? totalQty + ' / ' + target : totalQty + ' / 0');
    $text.hide();
     
    if (!target) {
      $offrs.text('');
      $text.text('');
    } else if (remain > 0) {
      $offrs.text('Boxprijs: ' + formatMoney(tierTotalCents(target)) + '.');
      $text.text(
        'Voeg ' +
          remain +
          ' maaltijd' +
          (remain === 1 ? '' : 'en') +
          ' toe om je box van ' +
          target +
          ' maaltijden te vullen.'
      );
    } else {
      $offrs.text('Je box is compleet.');
      $text.text('Boxprijs: ' + formatMoney(tierTotalCents(target)) + '.');
    }

    $bar.css({ width: progress + '%', backgroundColor: '#BBFF33' });

    $('.discoounted-codeed').hide();
  }

  function renderFreeShipBar(data) {
    const $headline = $(SELECTORS.freeShipHeadline);
    const $fill = $(SELECTORS.freeShipFill);
    $headline.text('Bezorging is altijd gratis.');
    $fill.css('width', '100%');
  }

  function toggleCheckoutEnable(data) {
    const { totalQty, requiredMeals } = data;
    const $btn = $(SELECTORS.cartGoBtn);

    if (requiredMeals > 0 && totalQty === requiredMeals) {
      $btn.removeClass('disabled').attr('aria-disabled', 'false');
    } else {
      $btn.addClass('disabled').attr('aria-disabled', 'true');
    }
  }

  function renderTotals() {
    const data = computeTotals();
    const { subtotalCents, discountCents, shippingCents, grandCents, totalQty } = data;

    $(SELECTORS.totalEl).text(formatMoney(subtotalCents));
    $(SELECTORS.discountEl).text('-' + formatMoney(discountCents));

    if (shippingCents > 0) {
  $(SELECTORS.shippingEl)
    .text(formatMoney(shippingCents))
    .css('color', '#fff');
} else {
  $(SELECTORS.shippingEl)
    .text('Gratis')
    .css('color', '#BF3');
}

    $(SELECTORS.grandEl).text(formatMoney(grandCents));
    $(SELECTORS.grandElMobile).text(formatMoney(grandCents));

    renderMealBanner(data);
    renderFreeShipBar(data);
    toggleCheckoutEnable(data);
    updateAutoselectVisibility(totalQty);
  }

  $('.autoselect-btn').on('click', function () {
    var targetMeals = getSelectedMinMeals();
    if (!targetMeals) return;

    var current = getTotalPendingQty();
    var toAdd = targetMeals - current;
    if (toAdd <= 0) return;

    var $allCards = $('.juo-card');
    if (!$allCards.length) return;

    function filterAvailable($set) {
      return $set
        .filter(function () {
          var variantId = String($(this).data('variant-id'));
          var item = pending.get(variantId);
          return !item || !item.qty;
        })
        .toArray();
    }

    function shuffle(arr) {
      for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [arr[i], arr[j]] = [arr[j], arr[i]];
      }
      return arr;
    }

    var chefCards = filterAvailable($allCards.filter('[data-ischef="true"]'));
    var otherCards = filterAvailable($allCards.not('[data-ischef="true"]'));

    shuffle(chefCards);
    shuffle(otherCards);

    function addFromList(list) {
      for (let idx = 0; idx < list.length && toAdd > 0; idx++) {
        var $card = $(list[idx]);
        var variantId = String($card.data('variant-id'));
        var priceCents = parseInt($card.data('price'), 10) || 0;
        var handle = String($card.data('product-handle'));
        var wantsSub = !!$card.data('selling-plan-group');

        var cur = pending.get(variantId) || {
          variantId,
          qty: 0,
          priceCents,
          handle,
          wantsSub,
        };

        if (cur.qty === 0) {
          cur.qty = 1;
          pending.set(variantId, cur);
          toAdd--;
        }
      }
    }

    addFromList(chefCards);
    if (toAdd > 0) addFromList(otherCards);

    renderCards();
    renderTotals();
    renderMiniCartFromPending();
  });

  $(document).on('click', SELECTORS.addBtn, function (e) {
    e.preventDefault();

    const requiredMeals = getSelectedMinMeals();
    const currentQty = getTotalPendingQty();
    if (requiredMeals > 0 && currentQty + 1 > requiredMeals) return;

    const $card = $(this).closest(SELECTORS.card);
    const variantId = String($card.data('variant-id'));
    const handle = String($card.data('product-handle'));
    const priceCents = parseInt($card.data('price'), 10) || 0;
    const wantsSub = !!$card.data('selling-plan-group');

    const cur = pending.get(variantId) || { variantId, qty: 0, priceCents, handle, wantsSub };

    cur.qty += 1;
    pending.set(variantId, cur);

    renderCards();
    renderTotals();
    renderMiniCartFromPending();
  });

  $(document).on('click', '.qty-btn', function () {
    const variantId = String($(this).data('variant-id'));
    const cur = pending.get(variantId);
    if (!cur) return;

    const requiredMeals = getSelectedMinMeals();

    if ($(this).hasClass('plus')) {
      const currentQty = getTotalPendingQty();
      if (requiredMeals > 0 && currentQty + 1 > requiredMeals) return;
      cur.qty += 1;
    } else if ($(this).hasClass('minus')) {
      cur.qty = Math.max(cur.qty - 1, 0);
    } else if ($(this).hasClass('remove')) {
      cur.qty = 0;
    }

    if (cur.qty === 0) pending.delete(variantId);
    else pending.set(variantId, cur);

    renderCards();
    renderTotals();
    renderMiniCartFromPending();
  });

  $(document).on('change', SELECTORS.dayRadio, function () {
    renderTotals();
    renderMiniCartFromPending();
  });

  $(document).on('change', '[name="purchase_type"]', function () {
    renderTotals();
    renderMiniCartFromPending();
  });

  $(document).on('click change', '.meal-card, .meal-card *', function () {
    const requiredMeals = getSelectedMinMeals();
    if (!requiredMeals) {
      renderTotals();
      renderMiniCartFromPending();
      return;
    }

    let totalQty = getTotalPendingQty();
    if (totalQty > requiredMeals) {
      let toRemove = totalQty - requiredMeals;
      const items = Array.from(pending.values()).filter((p) => p.qty > 0);

      for (let i = items.length - 1; i >= 0 && toRemove > 0; i--) {
        const p = items[i];
        const dec = Math.min(p.qty, toRemove);
        p.qty -= dec;
        toRemove -= dec;

        if (p.qty <= 0) pending.delete(p.variantId);
        else pending.set(p.variantId, p);
      }
    }

    renderCards();
    renderTotals();
    renderMiniCartFromPending();
  });

  const $btn = $('.checkout-btn');
  const originalText = $btn.html();

  function updateAttrDay(code, day) {
    const dayn = getSelectedDay();
    const coden = getDeliveryCode(day);
    var formData = new FormData();
    formData.append('attributes[DeliveryCode]', coden);
    formData.append('attributes[DeliveryDay]', dayn);

    fetch('/cart/update.js', {
      method: 'POST',
      body: formData,
    })
      .then((response) => response.json())
      .then(() => {
        $btn.removeClass('loading').html(originalText);
        window.location.href = '/cart';
      })
      .catch((error) => {
        console.error('Error updating cart:', error);
        $btn.removeClass('loading').html(originalText);
      });
  }

  function clearCart() {
    return fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
    });
  }

  $(SELECTORS.cartGoBtn)
    .unbind()
    .click(function (e) {
      if ($(this).hasClass('disabled')) {
        e.preventDefault();
        return;
      }
      e.preventDefault();

      const day = 'Wednesday';
      const code = getDeliveryCode(day);
      const entries = Array.from(pending.values()).filter((p) => p.qty > 0);

      $btn.addClass('loading').text('');

      if (entries.length === 0) {
        window.location.href = '/cart';
        return;
      }

      const itemsPayload = entries.map((p) => {
        const $card = $('.juo-card[data-variant-id="' + p.variantId + '"]');
        let sellingPlan = null;

        
          $card.find('.sell-item').each(function () {
            const planName = (($(this).data('planname') || '') + '').toLowerCase();
            const planId = $(this).data('plan');

            if (planName == 'delivery every week') {
              sellingPlan = planId;
              return false;
            }
          });
        

        const item = {
          id: Number(p.variantId),
          quantity: p.qty,
          properties: {
            _box: 'box-' + pid,
            _parent_product_handle: phandle,
            _parent_product_id: pid,
          },
        };

        if (sellingPlan) item.selling_plan = sellingPlan;
        return item;
      });

      clearCart()
        .then(() =>
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: itemsPayload }),
          })
        )
        .then((res) => {
          if (!res.ok) throw new Error('add failed');
          return res.json();
        })
        .then(() => updateAttrDay(code, day))
        .catch((err) => {
          console.error(err);
          alert('Kon items niet toevoegen. Probeer het opnieuw.');
          $btn.removeClass('loading').html(originalText);
        })
        .finally(() => $(this).removeClass('disabled').attr('aria-disabled', 'false'));
    });

  (function initCart() {
    renderCards();
    renderTotals();
    renderMiniCartFromPending();
  })();

  $('.order-summer-mobile').on('click', function () {
    $('.juo-cart').addClass('mobile-cart-active');
    renderCards();
    renderTotals();
    renderMiniCartFromPending();
  });

  $('.mobile-close-srawerr, .juo-overlay').on('click', function () {
    $('.juo-cart').removeClass('mobile-cart-active');
    $('.mobile.autoselect-wrapper').attr('hidden', true);
  });
});

    
$(document).ready(function(){
  const params = new URLSearchParams(window.location.search);
  const gpid = params.get('pid'); 
  if(params.has('pid')){
    $('.juo-card[data-variant-id="' + gpid + '"]').find('.add-to-cart').trigger('click');
  }else{
    
  }
  
});
window.addEventListener('pageshow', function () {
  document.querySelectorAll('input[type="radio"]').forEach(radio => {
    radio.checked = false;
  });
});

(function () {
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  } 
})();    